module.exports = __webpack_public_path__ + "img/2nd-grade-en.a9fe88c5.png";